import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import useBillingEventRemoveFiscalDocument from "../../hooks/useBillingEventRemoveFiscalDocument";

export default function RemoveFiscalDocument({ eventId }: { eventId: string; }) {
  const queryClient = useQueryClient();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const { mutate: removeFiscalDocument } = useBillingEventRemoveFiscalDocument({
    id: eventId,
    onSuccess: () => {
      setModalIsOpen(false);
      setIsError(false);
      queryClient.invalidateQueries({queryKey: ['billingEvent', eventId]})
    },
    onError: (error) => {
      if (error.response?.data.errors.base) {
        setModalIsOpen(false);
        setIsError(true);
        setMessages(error.response?.data.errors.base);
      }
    }
  });

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        setIsOpen={setModalIsOpen}
        Trigger={(
          <div className="flex items-center space-x-2">
            <Button
              operationKlassToCheckPermission="Admin::Billing::Events::RemoveFiscalDocument"
              data-testid="remove_event_with_fiscal_document_requirement_button"
            >
              Remover nota fiscal
            </Button>
          </div>
        )}
        title="Confirmar exclusão da Nota Fiscal"
        subtitle="Deseja realmente apagar esta Nota Fiscal? A transação voltará para o status Pendente e ficará aguardando novo upload."
        subtitleClassName="mt-2"
        titleClass="text-2xl"
        useCancellableFooter
        showClose={false}
        confirmButtonClassName="bg-danger"
        onConfirm={() => removeFiscalDocument()}
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError={isError}
          onClose={() => {
            queryClient.invalidateQueries({ queryKey: ['billingEvent', eventId] });
            queryClient.invalidateQueries({ queryKey: ['billingEvents'] });
          }}
        />
      )}
    </>
  );
}
